/**
 * Search for a long option list (SearchListPopover): an option matches when
 * its label contains every typed word, in any order and case, so "metro 12"
 * finds "Metrotech #12". Short lists don't get a search box. Same rule as the
 * mobile app's select (apps/mobile/src/components/select/filterSelectOptions).
 */

export interface SearchOption {
  value: string;
  label: string;
  /** Heading the option is listed under (e.g. its account); headings show when there are several. */
  group?: string;
  /** Quiet text at the right of the row (e.g. "12 active"). */
  detail?: string;
  /** Extra words the search matches besides the label (e.g. the account name). */
  keywords?: string;
}

/** Lists this long or longer get a search box. */
export const SEARCH_MIN_OPTIONS = 8;

export const shouldOfferSearch = (optionCount: number): boolean => optionCount >= SEARCH_MIN_OPTIONS;

export function filterOptionsByWords<T extends SearchOption>(options: T[], query: string): T[] {
  const words = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (words.length === 0) return options;
  return options.filter((opt) => {
    const text = `${opt.label} ${opt.keywords ?? ''}`.toLowerCase();
    return words.every((w) => text.includes(w));
  });
}
